import { isSentryEnabled } from './SentryUtils';
import Cookie from 'js-cookie';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/react';


/*
 * These are generic browser utilities
 */

// new Notification is on path to deprecation and Android does not support it.
// You must only call this *before* calling Notification.requestPermission(),
// otherwise this feature detect would bug the user with an actual notification!
// https://bugs.chromium.org/p/chromium/issues/detail?id=481856
export const isNewNotificationSupported = () => {
  if (!window.Notification || !Notification.requestPermission)
    return false;
  if (Notification.permission === 'granted')
    console.log('Permission already granted, new Notification() may or may not be supported.');
  try {
    new Notification('');
  } catch (e) {
    if (e.name === 'TypeError')
      return false;
  }
  return true;
};

// Helper function to bind event listeners
export const bindEvent = (element, eventName, eventHandler) => {
  if (element.addEventListener) {
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent(`on${eventName}`, eventHandler);
  }
};

export const logError = (msg = '', err = '') => {
  const errorString = `${msg}  ${err}`;
  isSentryEnabled() ? Sentry.captureMessage(errorString, Severity.Error) : console.error(errorString);
};

export const logWarning = (msg = '', err = '') => {
  const errorString = `${msg}  ${err}`;
  isSentryEnabled() ? Sentry.captureMessage(errorString, Severity.Warning) : console.warn(errorString);
};

export const _postMessage = (_window, message, targetOrigin) => {
  _window.postMessage(message, targetOrigin);
};

export const getCsrfToken = () => Cookie.get('XSRF-TOKEN');
